import { v4 as uuidv4 } from "uuid";
import { API_ENDPOINTS } from "../../enums/apiUrls";
import { getOrgIdForFetchExternalWorklist } from "../../utils/organizationHelper";
import { getBearerToken } from "./bearerToken";

interface PushToSftpPayload {
  file_names: string[];
  org_id: string;
  remote_dir: string;
  request_id: string;
  only_resubmit?: boolean;
}

export interface PushToSftpOptions {
  onlyResubmit?: boolean;
}

const getRemoteDir = (): string => {
  return process.env.REACT_APP_ENV === "production"
    ? "to_nycbs"
    : "risa_internal";
};

export interface SftpFileResult {
  status: string;
  message: string;
  filename: string;
  remote_path: string | null;
  file_size: number | null;
}

export interface FileWithInvalidCmmStatus {
  batch_id: string;
  record_count: number;
  failing_rules: string[];
  cmm_status_tracking_details?: Array<{
    record_id: string;
    cmm_st_rpa_status: string | null;
  }>;
}

export interface PushToSftpResponse {
  success: boolean;
  message: string;
  files_validated?: number;
  files_with_missing_cmm_id?: string[];
  files_with_invalid_cmm_status?: FileWithInvalidCmmStatus[];
  total_rows_checked?: number;
  rows_missing_cmm_id?: number;
  sftp_push_result?: {
    [originalFileName: string]: SftpFileResult;
  } | null;
  trace_id?: string;
}

export const pushFilesToSftp = async (
  fileNames: string[],
  options?: PushToSftpOptions,
): Promise<PushToSftpResponse> => {
  const payload: PushToSftpPayload = {
    file_names: fileNames,
    org_id: getOrgIdForFetchExternalWorklist(),
    remote_dir: getRemoteDir(),
    request_id: uuidv4(),
    ...(options?.onlyResubmit !== undefined && {
      only_resubmit: options.onlyResubmit,
    }),
  };
  try {
    const token = await getBearerToken();
    if (!token) {
      throw new Error("Bearer token not available");
    }

    const response = await fetch(API_ENDPOINTS.PUSH_FILES_TO_SFTP, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error pushing files to SFTP:", error);
    throw error;
  }
};
